import * as TechInventorySelectors from './tech-inventory.selectors';

export {TechInventorySelectors as TechInventorySelectors};
